import { render, staticRenderFns } from "./SearchTableBordeaux.vue?vue&type=template&id=2d49062a&"
import script from "./SearchTableBordeaux.vue?vue&type=script&lang=js&"
export * from "./SearchTableBordeaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports